import { TimePickerValue } from '../../../../../components/time-picker/time-picker';
import { CitizenLessonAttendanceState } from '../interfaces';

export interface RegistrationTimeWindow {
  beginAt: Date;
  endAt: Date;
}

export function checkInTimeToTimePickerValue(value?: Date | string): TimePickerValue {
  if (!value) {
    return undefined;
  }
  const date = new Date(value);
  return { hours: date.getHours(), minutes: date.getMinutes() };
}

export function timePickerValueToCheckInTime(baseValue: Date | string | undefined, timeValue: TimePickerValue): Date | undefined {
  if (!timeValue) {
    return undefined;
  }
  let hours: number;
  let minutes: number;
  if (typeof timeValue === 'string') {
    const [parsedHours, parsedMinutes] = timeValue.split(':').map(Number);
    hours = parsedHours;
    minutes = parsedMinutes;
  } else {
    hours = timeValue.hours;
    minutes = timeValue.minutes;
  }
  if (Number.isNaN(hours) || Number.isNaN(minutes)) {
    return undefined;
  }
  const date = baseValue ? new Date(baseValue) : new Date();
  date.setHours(hours, minutes, 0, 0);
  return date;
}

export function formatCheckInTime(value?: Date | string): string {
  if (!value) {
    return '';
  }
  return new Date(value).toLocaleTimeString('da-DK', { hour: '2-digit', minute: '2-digit' });
}

export function getRegistrationTimeWindow(citizenLessonAttendance: CitizenLessonAttendanceState, lessonBeginAt: Date | string, lessonEndAt: Date | string): RegistrationTimeWindow {
  const { hasLessonDeviation, lessonDeviationBeginAt, lessonDeviationEndAt } = citizenLessonAttendance;
  const beginAt = hasLessonDeviation && lessonDeviationBeginAt ? lessonDeviationBeginAt : lessonBeginAt;
  const endAt = hasLessonDeviation && lessonDeviationEndAt ? lessonDeviationEndAt : lessonEndAt;
  return { beginAt: new Date(beginAt), endAt: new Date(endAt) };
}

export function isRegistrationTimeWithinWindow(timeValue: TimePickerValue, timeWindow: RegistrationTimeWindow): boolean {
  const registrationTime = timePickerValueToCheckInTime(timeWindow.beginAt, timeValue);
  if (!registrationTime) {
    return true;
  }
  return minuteOfDay(registrationTime) >= minuteOfDay(timeWindow.beginAt) && minuteOfDay(registrationTime) <= minuteOfDay(timeWindow.endAt);
}

function minuteOfDay(value: Date): number {
  return value.getHours() * 60 + value.getMinutes();
}
